import React, { useMemo } from 'react';
import { Button } from '@this/shared/ui/inputs/button';

export interface CreditCardAccountingDataItem {
  id: number;
  year: number;
  month: number;
  created_at: string;
  aggregation_type: string;
}

interface Props {
  items: CreditCardAccountingDataItem[];
  encoding: string;
}

const formatPeriod = (year: number, month: number): string => `${year}年${month}月分`;

const formatCreatedAt = (createdAt: string): string => {
  const date = new Date(createdAt);
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

const getStyles = () => ({
  table: { width: 'auto' as const, tableLayout: 'auto' as const },
  buttonWrapper: { display: 'flex', gap: 8 },
  th: { padding: 4 },
  td: { padding: 4 }
});

export const CreditCardAccountingDataTable: React.FC<Props> = ({ items, encoding }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <table style={styles.table}>
      <tbody>
        <tr>
          <th style={styles.th}>対象期間</th>
          <th style={styles.th}>作成日</th>
          <th style={styles.th}>ダウンロード</th>
        </tr>
        {items.map(item => (
          <tr key={item.id}>
            <td style={styles.td}>{formatPeriod(item.year, item.month)}</td>
            <td style={styles.td}>{formatCreatedAt(item.created_at)}</td>
            <td style={styles.td}>
              <div style={styles.buttonWrapper}>
                <Button
                  size="small"
                  href={`/organization/credit_card_invoice_downloads/download?year=${item.year}&month=${item.month}`}
                  isExternal
                >
                  PDF
                </Button>
                <Button
                  size="small"
                  href={`/organization/credit_card_accounting_data/${item.id}.csv?encoding=${encoding}`}
                  isExternal
                >
                  会計用データ
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
